var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text",on:{"click":function($event){return _vm.openTermsOfService()}}},[_vm._v("\n  "+_vm._s(_vm.$l.termsAndConditionsIsHere)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }